import { ModalManager } from '@esign/modal';

import responsiveVideos from '../components/video/responsiveVideos';
import fileInputs from '../components/input/fileInput';
import validation from '../components/form/validation';
import cookieNotification from '../components/cookies/cookieNotification';
import PredictiveSearch from '../components/search/PredictiveSearch';
import CartModal from '../components/cart/CartModal';
import navigation from '../components/layout/navigation';
import swiper from '../components/layout/swiper';
import sliders from '../components/sliders/sliders';
import socialFeed from '../components/social/socialFeed';

import accordion from '../components/layout/accordion';
import Disclosure from '../components/layout/Disclosure';
import AddToCart from '../components/form/addToCart';
import hotspots from '../components/hotspots/hotspots';
import ScrollHeader from '../components/layout/scrollHeader';
import announcementModal from '../components/modal/announcementModal';
import buttonLoading from '../components/form/buttonLoading';

// Set js class
const htmlClassList = document.documentElement.classList;
htmlClassList.add('js');
htmlClassList.remove('no-js');

window.modalManager = new ModalManager();

const headerEl = document.querySelector('.js-scroll-header');

// initialize with default options
new ScrollHeader(headerEl);

// Layout setup
navigation();
responsiveVideos();
cookieNotification();
accordion();
swiper();
hotspots();
announcementModal();
socialFeed();
buttonLoading();

sliders();

// Add to cart forms
const productForms = document.querySelectorAll('.shopify-product-form');
productForms.forEach((productForm) => {
  new AddToCart(productForm);
});

// Forms
fileInputs();
validation();

// Cart
window.cartModal = new CartModal();

// Search
const searchBars = document.querySelectorAll('.search-bar');
searchBars.forEach((el) => {
  new PredictiveSearch(el);
});

// Disclosure
const disclosures = document.querySelectorAll('.disclosure');
disclosures.forEach((el) => {
  new Disclosure(el);
});

// Enable this if you want to test ga calls in development
// gaDevelopment();

window.modalManager.checkModalOnPageLoad();
